import { CALCULATOR_ACTIONS, CALCULATOR_STATE } from 'Constants/Store'

export default function CalculatorState(store) {
  store.on('@init', () => ({
    [CALCULATOR_STATE]: {},
  }))

  store.on(CALCULATOR_ACTIONS.UPDATE, (state, payload) => ({
    [CALCULATOR_STATE]: payload,
  }))
}
